import { useEmbarcacaoImagens } from "../../../../hooks/use-embarcacao-imagens";
import { latestAtualizacao } from "../../../detail-format/detail-format";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  IMAGENS_EMPTY_STATE,
  IMAGENS_FIELDS,
  IMAGENS_ID,
  IMAGENS_LOADING_MESSAGE,
  IMAGENS_TEST_ID,
  IMAGENS_TITLE,
} from "./imagens-section.constants";

/**
 * Seção Imagens do detalhamento da embarcação: galeria das imagens da embarcação consultada (RN001), somente para
 * consulta e download (RN002/RN003). A imagem sem endereço fica fora da galeria.
 */
export function useImagensSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, imagens, errorMessage, reload } = useEmbarcacaoImagens(embarcacaoId);

  return {
    id: IMAGENS_ID,
    title: IMAGENS_TITLE,
    testId: IMAGENS_TEST_ID,
    galleryTestId: `${IMAGENS_TEST_ID}-gallery`,
    status,
    errorMessage,
    loadingMessage: IMAGENS_LOADING_MESSAGE,
    emptyContent: IMAGENS_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: imagens
      ? latestAtualizacao([imagens.ultimaAtualizacao, imagens.atualizacaoImagens])
      : undefined,
    cards: IMAGENS_FIELDS.flatMap(({ key, label, principal }) => {
      const url = imagens?.[key];

      return url ? [{ key, embarcacaoId, url, label, principal }] : [];
    }),
  };
}
